import { render } from "./HomePagePart2ArtGallery.vue?vue&type=template&id=2a529f94&scoped=true"
import script from "./HomePagePart2ArtGallery.vue?vue&type=script&lang=js"
export * from "./HomePagePart2ArtGallery.vue?vue&type=script&lang=js"

import "./HomePagePart2ArtGallery.vue?vue&type=style&index=0&id=2a529f94&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a529f94"]])

export default __exports__